import React, { useState } from 'react';
import InputForm from '../../../../InputT';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, Chip, Typography } from '@mui/material';
import { Button, Form } from 'antd';
import { MonetizationOnOutlined, SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SearchInput from '../../../../SearchInput';
import SearchModal from '../../../../SearchModal';
import Datas from "../../../../../Data/Data.json"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Data from '../../../../../Data/Data.json'
import SelectOption from '../../../../SelectOption';
import ParamsQard from '../../../../../Models/ParamsQard';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';

// ==================== PARAMÈTRES DE RECHERCHE ====================
let searchFinForm: Params = { CodeAgence: '', Table: "DEMAND_FINQARD", Colonne1: "NumeroDemande", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }

// ==================== FONCTION DE STYLE DU STATUT ====================
/**
 * Retourne la couleur, le fond et le libellé du statut à afficher.
 * On se base prioritairement sur StatutDemande ; si absent, on retombe sur EtapeActuelle.
 */
const getStatutStyle = (etape?: string, statutDemande?: string) => {
  const statutUpper = (statutDemande || '').toUpperCase();
  const etapeUpper = (etape || '').toUpperCase();

  switch (statutUpper) {
    case 'EN_ATTENTE':
      return { color: '#faad14', bg: '#fffbe6', label: 'En attente' };
    case 'VALIDEE':
    case 'VALIDÉE':
      return { color: '#52c41a', bg: '#f6ffed', label: 'Validée' };
    case 'REJET':
    case 'REJETEE':
    case 'REJETÉE':
      return { color: '#f5222d', bg: '#fff1f0', label: 'Rejetée' };
    case 'EN_ANALYSE':
      return { color: '#1890ff', bg: '#e6f7ff', label: 'En analyse' };
    case 'BROUILLON':
      return { color: '#8c8c8c', bg: '#f5f5f5', label: 'Brouillon' };
    case 'ANNULE':
    case 'ANNULÉE':
      return { color: '#8c8c8c', bg: '#f5f5f5', label: 'Annulée' };
  }

  // Fallback : si StatutDemande est vide mais qu'on a un EtapeActuelle
  if (etapeUpper) {
    return { color: '#8c8c8c', bg: '#f5f5f5', label: etapeUpper };
  }

  return { color: '#8c8c8c', bg: '#f5f5f5', label: 'Non défini' };
};

// ==================== INTERFACE DES PROPS ====================
interface Tab1Props {
  form?: any;
  disabled?: boolean;
  LoadGarantie: Function;
  Numcli: string;
  CodeQard: string;
  setNumcli: (value: string) => void;
  setCodeQard: (value: string) => void;
  setParamsQard?: (value: ParamsQard | null) => void;
}

function Tab1(props: Tab1Props) {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const [loading, setLoading] = useState(false);

  const [RVMontantMaxAuto, SetRVMontantMaxAuto] = useState<RegExp>(/^[0-9]*$/);
  const [NombreEchMAX, SetNombreEchMAX] = useState<RegExp>(/^[0-9]*$/);
  const [MontantMinPromesse, SetMontantMinPromesse] = useState<number>(0);
  const [TauxMinPromesse, SetTauxMinPromesse] = useState<number>(0);

  const authHeader = useAuthHeader();

  // ✅ useWatch pour le statut (fonctionne avec les Form.Item enregistrés plus bas)
  const EtapeActuelle = Form.useWatch('EtapeActuelle', props.form);
  const StatutDemande = Form.useWatch('StatutDemande', props.form);
  const codeQardValue = Form.useWatch('CodeQard', props.form);

  // Les autres champs ne sont sélectionnables qu'après le choix du Code Qard
  const fieldsDisabled = !codeQardValue;

  let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
  let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
  let searchNumCompte: Params = { CodeAgence: props.Numcli ? props.Numcli : "54", Table: "ViewAnyQardCptRembousmt", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "NUMCLI", colfiltre: 'CodeQard', valfiltre: props.CodeQard, Choix: 22 }
  let searchNature: Params = { CodeAgence: 'ACTIVITE', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
  let searchObjet: Params = { CodeAgence: 'OBJETFIN', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
  let searchMotif: Params = { CodeAgence: 'MOTIFPRET', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
  let searchSimul: Params = { CodeAgence: '', Table: "SimulationQard", Colonne1: "CodeSimul", Colonne2: "Nomcli", Colagence: '101', Choix: 22 }
  let searchParamsQard: Params = { CodeAgence: '', Table: "ParamsQard", Colonne1: "CodeQard", Colonne2: "LibelleQard", Colagence: '101', Choix: 22 }

  // ==================== FONCTIONS UTILITAIRES ====================
  function generateMaxNumberRegExp(max: number): RegExp {
    if (!max || isNaN(max)) return /^[0-9]*$/;

    let pattern = "^(";
    let maxStr = max.toString();
    let len = maxStr.length;

    if (len > 1) {
      pattern += `[0-9]{1,${len - 1}}|`;
    }

    for (let i = 0; i < len; i++) {
      let currentDigit = parseInt(maxStr[i]);
      if (currentDigit === 0 && i === 0) continue;

      let prefix = maxStr.substring(0, i);

      if (currentDigit > 0) {
        let range = currentDigit === 1 ? "0" : `0-${currentDigit - 1}`;
        let remainingLength = len - 1 - i;
        let suffix = remainingLength > 0 ? `[0-9]{${remainingLength}}` : "";
        pattern += `${prefix}[${range}]${suffix}|`;
      }
    }

    pattern += `${maxStr})$`;

    return new RegExp(pattern);
  }

  function getMinimumPromesse(): number {
    const montantDemande = Number(props.form.getFieldValue("MontantDemande")) || 0;
    return MontantMinPromesse + (montantDemande * TauxMinPromesse) / 100;
  }

  const promesseRules = [
    {
      validator: (_: any, value: any) => {
        if (value === null || value === undefined || value === '') return Promise.resolve();
        const minimum = getMinimumPromesse();
        if (Number(value) < minimum) {
          return Promise.reject(new Error(`Le montant de la promesse doit être au moins de ${formatNumber(minimum)}`));
        }
        return Promise.resolve();
      }
    }
  ];

  const datePremEchRules = [
    {
      validator: (_: any, value: any) => {
        if (value === null || value === undefined || value === '') return Promise.resolve();
        const toDay = (d: any) => { const dt = new Date(d); dt.setHours(0, 0, 0, 0); return dt.getTime(); };
        if (toDay(value) < toDay(user.datjour)) {
          return Promise.reject(new Error('La date du 1er remboursement ne doit pas être antérieure à la date du jour'));
        }
        return Promise.resolve();
      }
    }
  ];

  // ==================== CONSULTATION TYPE QARD ====================
  function consultTypecard() {
    if (props.form.getFieldValue("CodeQard") == null) {
      SweetAlert.fire({ title: "Svp renseigner le Code du type de Qard ", icon: "warning" });
    } else {
      let data = props.form.getFieldValue("CodeQard");
      props.setCodeQard(data);
      props.form.setFieldValue("CPTREMBOURSEMENT", '');

      if (data.length != 0) {
        setLoading(true)
        let config =
        {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsQard,
          headers: {
            'CypherCodeQard': Crypter.encrypt(data),
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
        };

        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                let paramsQardData: ParamsQard = res.Result.Table1[0];

                if (props.setParamsQard) props.setParamsQard(paramsQardData);

                if (paramsQardData.MontantMaxAuto) {
                  const regexMontant = generateMaxNumberRegExp(Number(paramsQardData.MontantMaxAuto));
                  SetRVMontantMaxAuto(regexMontant);
                }

                if (paramsQardData.NbrEchMax) {
                  const regexEcheance = generateMaxNumberRegExp(Number(paramsQardData.NbrEchMax));
                  SetNombreEchMAX(regexEcheance);
                }

                SetMontantMinPromesse(Number(paramsQardData.MontantMinPromesse) || 0);
                SetTauxMinPromesse(Number(paramsQardData.TauxMinPromesse) || 0);

                props.form.setFieldValue("CodeFrais", paramsQardData.Frais);
              }
              else {
                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
              }
            }
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          });
      }
    }
  }

  // ==================== CHANGEMENT DE CLIENT ====================
  function handleClientChange() {
    props.form.setFieldValue("CPTREMBOURSEMENT", '');
    if (props.form.getFieldValue("NUMCLI")) {
      props.setNumcli(props.form.getFieldValue("NUMCLI"))
    }
  }

  // ==================== CHARGEMENT D'UNE SIMULATION ====================
  function load() {
    let data = Crypter.encrypt(props.form.getFieldValue("CodeSimul"));
    let codeSimul = props.form.getFieldValue("CodeSimul")

    if (data.length != 0) {
      setLoading(true)
      props.form.resetFields();
      props.form.setFieldValue('CodeSimul', codeSimul)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadSimulationQard,
        headers: {
          'CypherCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              const sim = res.Result.Table2[0];
              props.form.setFieldsValue({
                ...sim,
                CodeSimul: sim.CodeSimul,
                CodeQard: sim.CodeQard,
                lib_CodeQard: sim.lib_CodeQard ?? sim.LibelleQard,
                NUMCLI: sim.Numcli,
                NOMCLI: sim.NOMCLI ?? sim.NOM ?? sim.Nomcli,
                lib_NUMCLI: sim.lib_NUMCLI ?? sim.NOM ?? sim.Nomcli,
                CODOBJECT: sim.CODOBJECT,
                lib_CODOBJECT: sim.lib_CODOBJECT ?? sim.LibelleObjet,
                MOTIFDEM: sim.MOTIFDEM,
                lib_MOTIFDEM: sim.lib_MOTIFDEM ?? sim.LibelleMotif,
                CODACTIVE: sim.CODACTIVE,
                lib_CODACTIVE: sim.lib_CODACTIVE ?? sim.LibelleActivite,
                MontantDemande: sim.MontantDemande ?? sim.Montant,
                MontantPromesse: sim.MontantPromesse,
                NombreEch: sim.NombreEch,
                Periodicite: sim.Periodicite,
                lib_Periodicite: sim.lib_Periodicite ?? sim.LibellePeriodicite,
                DatePremEch: sim.DatePremEch ? ReformatDate(sim.DatePremEch) : undefined,
                CommentaireDemande: sim.CommentaireDemande,
                CPTREMBOURSEMENT: '',
              });

              // Executeafter : mêmes traitements qu'une sélection manuelle des champs remplis
              handleClientChange();
              props.LoadGarantie();
              consultTypecard();
            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }

  // ==================== STYLE DU STATUT ====================
  const statutStyle = getStatutStyle(EtapeActuelle, StatutDemande);

  // ==================== RENDU ====================
  return (
    <div className='tabItem'>
      <div>
        <Box fontStyle={"inherit"} display={"flex"}>
          <SearchModal notRequired width={7} form={props.form} Titre='Recherche de simulation du financement Qard Hassan' label='Code Simulation' name='CodeSimul' Parametre={searchSimul} />
          <Button onClick={load} style={{ top: '10px', color: 'white' }} className='bt_add' type="ghost">
            {loading ? <CircularProgress size={"20px"} /> : "Load"}
          </Button>
        </Box>

        <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>

          {/* ✅ CHAMPS CACHÉS : enregistre EtapeActuelle et StatutDemande dans le formulaire pour Form.useWatch */}
          <Form.Item name="EtapeActuelle" noStyle>
            <input type="hidden" />
          </Form.Item>
          <Form.Item name="StatutDemande" noStyle>
            <input type="hidden" />
          </Form.Item>

          {/* ===== BANDEAU DE STATUT ===== */}
          {!props.disabled && (EtapeActuelle || StatutDemande) && (
            <Grid item xs={12} md={12} lg={12} sx={{ p: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 2,
                  px: 2,
                  py: 1.5,
                  bgcolor: statutStyle.bg,
                  borderBottom: `2px solid ${statutStyle.color}`,
                  borderRadius: '4px 4px 0 0',
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#333' }}>
                  Statut de la demande :
                </Typography>
                <Chip
                  label={statutStyle.label}
                  sx={{
                    bgcolor: statutStyle.color,
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: 12,
                    height: 26,
                  }}
                />
                <Typography sx={{ ml: 'auto', fontSize: 12, color: '#666' }}>
                  Étape code : <b>{EtapeActuelle || 'N/A'}</b>
                </Typography>
              </Box>
            </Grid>
          )}

          {/* ======= COLONNE GAUCHE ======= */}
          <Grid item xs={12} md={6} lg={6} className='border-left'>
            <SearchInput dissabledCode={props.disabled} notRequired width={4} form={props.form} Titre='Recherche Numéro de financement Qard' label='Numéro' name='NumeroDemande' Parametre={searchFinForm} />
            <SearchModal disabled={fieldsDisabled} ExecuteafterSelect1={props.LoadGarantie} ExecuteafterSelect2={handleClientChange} width={4} form={props.form} Titre="Recherche Indice client" label='Indice client' name='NUMCLI' Parametre={searchIndice} />
            <Box margin={1} fontStyle={'inherit'}>
              <label htmlFor="">Compte de remboursement </label>
              <SelectOption disabled={fieldsDisabled} Size={'large'} label="" name="CPTREMBOURSEMENT" Parametre={searchNumCompte} />
            </Box>

            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche Objet du financement" label='Objet du financement' name='CODOBJECT' Parametre={searchObjet} />
            <InputForm notRequired width={4} disabled money label='Frais de service' icon={<SwipeUp color='disabled' fontSize='small' />} name='MontantFrais' type='number' error='mobile' />
            <SearchModal disabled={fieldsDisabled} width={5} form={props.form} Titre="Recherche Motif " label='Motif demande' name='MOTIFDEM' Parametre={searchMotif} />
          </Grid>

          {/* ======= COLONNE DROITE ======= */}
          <Grid item xs={12} md={6} lg={6} className='border-left'>
            <SearchModal ExecuteafterSelect1={consultTypecard} width={4} form={props.form} Titre="Recherche Type de financement Qard" label='Type de Qard' name='CodeQard' Parametre={searchParamsQard} />
            <InputForm disabled={fieldsDisabled} width={4} MessExp='Le montant de la demande doit être inférieur ou égal au montant maximum autorisé' money RegExp={RVMontantMaxAuto} label='Montant demande' icon={<MonetizationOnOutlined fontSize='small' />} name='MontantDemande' type='number' error='mobile' />
            <InputForm disabled={fieldsDisabled} defaultValue={0} width={4} money rules={promesseRules} dependencies={['MontantDemande']} label='Montant promesse' icon={<MonetizationOnOutlined fontSize='small' />} name='MontantPromesse' type='number' error='mobile' />
            <InputForm disabled={fieldsDisabled} width={4} money MessExp="Le nombre d'échéances doit être inférieur ou égal au nombre autorisé" RegExp={NombreEchMAX} label='Nbre échéance' icon={<MonetizationOnOutlined fontSize='small' />} name='NombreEch' type='number' error='mobile' />
            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche Périodicité" label='Périodicité' name='Periodicite' Parametre={searchPeriod} />
            <InputForm disabled={fieldsDisabled} width={4} rules={datePremEchRules} label='Date 1ère remboursement' icon={<MonetizationOnOutlined fontSize='small' />} name='DatePremEch' type='date' error='mobile' />
            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche Secteur d'activité" label='S. activité' name='CODACTIVE' Parametre={searchNature} />
          </Grid>

          {/* ======= COMMENTAIRE PLEINE LARGEUR ======= */}
          <Grid item xs={12} md={12} lg={12} className='border-left'>
            <InputForm disabled={fieldsDisabled} width={4} label='Commentaire' icon={<SwipeUp color='disabled' fontSize='small' />} name='CommentaireDemande' type='TextArea' error='mobile' />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default Tab1;